import {observable} from 'mobx';

let key = 1;

export default class GroupProduct {
	@observable product_id = 0;
	@observable product_name = '';
	@observable label = '';
	@observable is_primary = false;

	_key;

	constructor(product) {
		if (product) {
			this.product_id = parseInt(product.product_id);
			this.product_name = product.product_name;
			this.label = product.label;
			this.is_primary = product.is_primary;
		}

		this._key = key++;
	}
}